import { getOfficeStatusDetailsInfo } from "../../../../../actions/Utilities/OfficeStatusDetails";
import { useQuery } from "react-query";

export default function useOfficeStatusDetails() {
  return useQuery("OfficeStatusDetails", getOfficeStatusDetailsInfo, {
    refetchOnWindowFocus: false
  });
}
